angular.module('app').factory('LoadBlog', function ($resource, backendConfig) {
    return $resource(backendConfig.url + '/loadblog/:id', {id: '@id'}, {
        query: {method: 'GET', isArray: false}
    });
});